import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyName, SurveyNameDTO } from "./surveyName";

export interface SurveyIdAndNameDTO {
  surveyId: string;
  surveyName: SurveyNameDTO;
}

export class SurveyIdAndName {
  readonly isSurveyIdAndNameSurveyIdAndName: boolean = true;

  readonly surveyId: LeoUUID;
  readonly surveyName: SurveyName;


  constructor(
  surveyId: LeoUUID, 
  surveyName: SurveyName
  ) {
    this.surveyId = surveyId;
    this.surveyName = surveyName;
  }

  static fromDTO(dto: SurveyIdAndNameDTO): SurveyIdAndName {
    const surveyId = getLeoUuid(dto, "surveyId", InvalidSurveyIdAndNameSurveyIdError);
    const surveyName = SurveyName.fromDTO(getObject(dto, "surveyName", InvalidSurveyIdAndNameSurveyNameError));
    return new SurveyIdAndName(
      surveyId,
      surveyName
    );
  }

  toDTO(): SurveyIdAndNameDTO {
    const dto: SurveyIdAndNameDTO = {
        surveyId: this.surveyId.toDTO(),
        surveyName: this.surveyName.toDTO()
    };
    return dto;
  }
  }

SurveyIdAndName.prototype.toString = function toString(): string {
  return `SurveyIdAndName(surveyId='${this.surveyId}',surveyName='${this.surveyName}')`;
};

export class InvalidSurveyIdAndNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyIdAndNameError";
  }
}
export class InvalidSurveyIdAndNameSurveyIdError extends InvalidSurveyIdAndNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyIdAndNameSurveyIdError";
  }
}

export class InvalidSurveyIdAndNameSurveyNameError extends InvalidSurveyIdAndNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyIdAndNameSurveyNameError";
  }
}
